<template>
  <div id="section-to-print" style="padding: 40px;">
    <h3 style="text-align:center; margin-top: 10px; margin-bottom: 20px; font-family: Khmer Os Moul, 'Hanuman-Regular'">ទម្រង់ស្នើរសុំទម្លាក់កម្ចីវិក័យបត្រស្រូវ</h3>
    <table style="font-size; 14px;">
        <tbody>
          <tr>
            <td style="text-align: justify; white-space: break-spaces; line-height: 2.5">
              ឈ្មោះឈ្មួញលក់ស្រូវ<b class="underline">{{ datas.crop_trader_name }}</b>វិក័យបត្រលេខ<b class="underline">{{ datas.invoice_no }}</b>
              ស្លាកលេខឡាន<b class="underline">{{ datas.truck_plat_no }}</b>ប្រភេទស្រូវ<b class="underline">{{ datas.crop_type_name }}</b>ទម្ងន់<b class="underline">{{ parseFloat(datas.quantity) + 'KG' }}</b>តម្លៃរាយ<b class="underline">{{ parseFloat(datas.price) | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</b>
              តម្លៃសរុប<b class="underline">{{ parseFloat(datas.quantity * datas.price) | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</b>ចេញដោយរោងម៉ាស៊ីនឈ្មោះ<b class="underline">{{ datas.miller_name }}</b>
              កាលបរិច្ឆេទចេញវិក័យបត្រ<b class="underline">{{ datas.invoice_date | dateFormat }}</b>កាលបរិច្ឆេទបើកប្រាក់ក្នុងវិក័យបត្រ<b class="underline">{{ datas.invoice_settlement_date | dateFormat }}</b>
              សូមស្នើរសុំទម្លាក់កម្ចីចំនួន<b class="underline">{{ datas.drawdown_amount | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</b>នៅថ្ងៃទី ខែ ឆ្នាំ<b class="underline">{{ datas.drawdown_date | dateFormat }}</b>
              ដោយសន្យាសងប្រាក់វិញនៅថ្ងៃទី ខែ ឆ្នាំ<b class="underline">{{ datas.drawdown_date | dateFormat }}</b>តាមរយះយកវិក័យត្រស្រូវទៅបើកលុយ
              ករណីមានការពន្យាការបើប្រាក់ដោយប្រការណាមួយ ខ្ញុំបាន/នាងខ្ញុំ យល់ព្រមទទួលពិន័យតាមលក្ខណ្ឌ
              របស់ក្រុមហ៊ុនដោយគ្មានការប្រកែកឡើង។<br>
              ខ្ញុំបាទ/នាងខ្ញុំ សូមបញ្ជាក់ថា រាល់ព៍តមានដែលបានរៀបរាប់ខាងលើពិតជាត្រូវពិតប្រាកដមែន ប្រសិនបើផ្ទុយពី
              ការពិត ខ្ញុំបាទ/នាងខ្ញុំយល់ព្រមទទួលខុសត្រូវចំពោះមុខច្បាប់។
            </td>
          </tr>
         <tr>
            <td style="padding-top: 50px;">
              <div style="width: 50%; float: left; text-align: center">ស្នើរដោយ</div>
              <div style="width: 50%; float: right; text-align: center">ពិនិត្យដោយ</div>
            </td>
          </tr>
          <tr>
              <td>
                <div style="width: 50%; float: left; text-align: center"><b>{{datas.crop_trader_name}}</b></div>
                <div style="width: 50%; float: right; text-align: center"><b>{{datas.review_by_name}}</b></div>
              </td>
          </tr>
        </tbody>
    </table>
  </div>
</template>

<style scoped>
  .underline {
    border-bottom: 1.5px dotted;
    padding: 0 15px;
  }
</style>

<script>

import {provider} from "@/service/provider";
import axios from "axios";
import MainMixin from "../../../mixins/mainMixin";

export default {
  mixins: [MainMixin],
  data() {
    return {
      params: {},
      datas: {}
    }
  },

  methods: {
    handleRun() {
      if(Object.keys(this.params).length){
        let vm      = this;
        let url     = provider.baseURL + provider.fetchListInvoiceFinanceRequestDrawdown;
        
        let query  = {
            search: "",
            id: this.params.id,
            crop_trader_id: this.params.crop_trader_id,
            application_no: this.params.application_no,
            offset:0,
            limit: vm.itemsPerPage,
            sort_by: "created_at",
            sort_desc:1,
            from_date: "",
            to_date: "",
        };

        axios.post(url, query, {headers: {Authorization: localStorage.token}}).then(res => {
          if (res.data.response && res.data.response.code === 200) {
            vm.datas = res.data.data[0];
            vm.$nextTick(() => { window.print(); });
            vm.$nextTick(() => { this.$router.back(); });
          }
        }).catch(error => console.log(error));

      }else{
        this.$router.back();
      }
    }
  },
  mounted(){ this.handleRun() },
  created() { 
    this.params = this.$route.params;
  }
}
</script>